import { Checkbox, Form } from 'antd';
import generatePicker from 'antd/es/date-picker/generatePicker';

import { dateGenerateConfig } from 'app/components/fields/dateGenerateConfig';
import {
  addDays,
  addYears,
  isAfter,
  isBefore,
  startOfDay,
} from 'app/utils/dayjs';

import { RULES } from '../BulkEdit';

type DatesSelectorProps = {
  startDate?: Date;
  endDate?: Date;
  days?: number[];
  fromDate?: Date;
};

export const BULK_EDIT_DEFAULT_DAYS = [1, 2, 3, 4, 5, 6, 7];

export const DAYS_OPTIONS = [
  { label: 'Mon', value: 1, fullName: 'Monday' },
  { label: 'Tue', value: 2, fullName: 'Tuesday' },
  { label: 'Wed', value: 3, fullName: 'Wednesday' },
  { label: 'Thu', value: 4, fullName: 'Thursday' },
  { label: 'Fri', value: 5, fullName: 'Friday' },
  { label: 'Sat', value: 6, fullName: 'Saturday' },
  { label: 'Sun', value: 7, fullName: 'Sunday' },
];

const DatePicker = generatePicker<Date>(dateGenerateConfig);

const TODAY = new Date();

export const DatesSelector = ({
  startDate,
  endDate,
  days,
  fromDate,
}: DatesSelectorProps) => {
  return (
    <section className="bulkEdit__body__selectedDates">
      <h2>Selected dates</h2>
      <div className="bulkEdit__body__selectedDates_pickers">
        <div className="from">
          <Form.Item
            label="From"
            name="startDate"
            rules={RULES}
            initialValue={startDate}
          >
            <DatePicker
              format={'ddd DD MMM'}
              disabledDate={(d) =>
                !d ||
                isBefore(d, startOfDay(TODAY)) ||
                isAfter(d, addYears(TODAY, 1))
              }
              showToday
            />
          </Form.Item>
        </div>
        <div className="upTo">
          <Form.Item
            label="Up to and including:"
            name="endDate"
            rules={RULES}
            initialValue={endDate}
          >
            <DatePicker
              format={'ddd DD MMM'}
              disabledDate={(d) =>
                !d ||
                isBefore(d, addDays(fromDate || TODAY, 1)) ||
                isAfter(d, addYears(TODAY, 2))
              }
              showToday
              disabled={!fromDate}
            />
          </Form.Item>
        </div>
      </div>
      <div className="bulkEdit__body__selectedDates_applyTo">
        <p className="subtitle">
          Which day of the week do you want to apply changes to:
        </p>
        <div className="listCheckbox">
          <Form.Item name="days" initialValue={days ?? BULK_EDIT_DEFAULT_DAYS}>
            <Checkbox.Group options={DAYS_OPTIONS} />
          </Form.Item>
        </div>
      </div>
    </section>
  );
};
